// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Uqi0","content":"styles_content__30bmJ"};